import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { languages } from '../i18n';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  
  // Initialize language from i18n's detected language
  const [language, setLanguage] = useState(i18n.language);

  // Listen for language changes in i18n
  useEffect(() => {
    const handleLanguageChanged = (lng) => {
      setLanguage(lng);
    };

    // Subscribe to language change event
    i18n.on('languageChanged', handleLanguageChanged);
    
    // Cleanup subscription
    return () => {
      i18n.off('languageChanged', handleLanguageChanged);
    };
  }, [i18n]);

  // Function to toggle language
  const toggleLanguage = () => {
    const currentIndex = languages.indexOf(language);
    const nextIndex = (currentIndex + 1) % languages.length;
    const newLanguage = languages[nextIndex];
    i18n.changeLanguage(newLanguage);
    // No need to manually save to localStorage as LanguageDetector does this
  };
  
  // Function to explicitly set language
  const setAppLanguage = (lng) => {
    if (languages.includes(lng)) {
      i18n.changeLanguage(lng);
    }
  };
  
  return (
    <LanguageContext.Provider value={{ 
      language, 
      toggleLanguage,
      setLanguage: setAppLanguage,
      availableLanguages: languages
    }}>
      {children}
    </LanguageContext.Provider>
  );
};
// import React, { createContext, useState, useEffect } from 'react';
// import { useTranslation } from 'react-i18next';

// export const LanguageContext = createContext();

// export const LanguageProvider = ({ children }) => {
//   const { i18n } = useTranslation();
  
//   // Initialize language from localStorage or default to 'en'
//   const [language, setLanguage] = useState(() => {
//     const savedLanguage = localStorage.getItem('language');
//     return savedLanguage || 'en';
//   });

//   // Effect to sync i18n language with our context
//   useEffect(() => {
//     i18n.changeLanguage(language);
//     localStorage.setItem('language', language);
//   }, [language, i18n]);

//   // Function to toggle language
//   const toggleLanguage = () => {
//     const newLanguage = language === 'en' ? 'es' : 'en';
//     setLanguage(newLanguage);
//   };
  
//   return (
//     <LanguageContext.Provider value={{ language, toggleLanguage }}>
//       {children}
//     </LanguageContext.Provider>
//   );
// };